import { createContext, useContext } from 'react'

import type { TEnvioDocumentosContext } from '@/features/enviar-documentos/interfaces'

export const EnvioDocumentosContext = createContext<TEnvioDocumentosContext | null>(null)

export const useEnvioDocumentosContext = () => {
  const context = useContext(EnvioDocumentosContext)
  if (!context) {
    throw new Error('useEnvioDocumentosContext should be used within <EnvioDocumentos>')
  }
  return context
}
